export const garmentFamiliesColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  {
    id: 'nombre',
    label: 'Nombre',
    type: 'text',
    sortable: true,
    required: true,
  },
  {
    id: 'descripcion',
    label: 'Descripción',
    type: 'text',
    sortable: true,
    required: true,
  },
  {
    id: 'actions',
    label: 'Acciones',
    key: 'actions',
    actions: [
      {
        key: 'edit',
        label: 'Editar',
        icon: 'Edit',
        tooltip: 'Editar familia',
        className: 'text-green-600 hover:text-green-700',
      },
      {
        key: 'delete',
        label: 'Eliminar',
        icon: 'Trash',
        tooltip: 'Eliminar familia',
        className: 'text-red-600 hover:text-red-700',
      },
    ],
  },
];

export const columnsExcel = [
  { header: 'Nombre', key: 'nombre' },
  { header: 'Descripción', key: 'descripcion' },
  { header: 'Estado', key: 'estado' },
];
